module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-2@2x.571955b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-2@2x.png
// module id = Fv/Z
// module chunks = 18